import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, RelationId, TableInheritance} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Player, Team} from "@/modules/team/entity";
import {Match} from ".";
import {Component} from "@vue/runtime-core";
import {ShallowRef} from "vue";

@Entity({orderBy: {minute: 'ASC'}})
@TableInheritance({column: {type: "varchar", name: "type"}})
export class Incident extends BaseEntity {
  @ManyToOne(() => Match, r => r.incidents)
  match: Relation<Match>;

  @ManyToOne(() => Team, {nullable: true})
  team?: Relation<Team>;

  @ManyToOne(() => Player, {nullable: true})
  player?: Relation<Player>;

  @RelationId((i: Incident) => i.player)
  playerId?: number;

  @Column({type: 'integer'})
  minute: number;

  get fullWidth() {
    return false;
  }

  get component(): ShallowRef<Component> {
    throw 'No component defined';
  }

  get liveComponent(): ShallowRef<Component> {
    throw 'No component defined';
  }
}
